import { $ajax, $exportAjax } from '../api'

// 数据页面
export default class Data {

    constructor() {}

    static data = {
      readHoursParam: '/api/mo-data/data/readHoursParam.action',     //按小时查询
      readDateParams: '/api/mo-data/data/readDateParam.action',      //按天查询
      readDataLast: '/api/mo-data/data/readDataLast.action',         //读取设备最新数据
      deviceEvents: '/api/mo-data/data/eventList.action',            //操作事件列表
      aiAsk: '/api/mo-data/ai/chat.action',                          //AI问答
      deviceMeters: '/api/mo-data/energy/deviceMeters.action',
      hourEnergy: '/api/mo-data/energy/hourEnergy.action',
      staticEnergy: '/api/mo-data/energy/staticEnergy.action',
      meterList: '/api/mo-data/energy/meterList.action',
      meterParent: '/api/mo-data/energy/meterParent.action',
      freezerZongHe: '/api/mo-data/energy/freezerZongHe.action',
      freezerEnergyHours: '/api/mo-data/energy/freezerEnergyHours.action',
      freezerEnergyMonth: '/api/mo-data/energy/freezerEnergyMonth.action',
      freezerEnergyYear: '/api/mo-data/energy/freezerEnergyYear.action',
      freezerEnergyMeter: '/api/mo-data/energy/freezerEnergyMeter.action',
      freezerEnergy: '/api/mo-data/energy/freezerEnergy.action',
      kuwenData: '/api/mo-data/energy/kuwenData.action',
      fengjiData: '/api/mo-data/energy/fengjiData.action',
      yunxingData: '/api/mo-data/energy/yunxingData.action',
      energyExport: '/api/mo-data/energy/energyExport.action',
      exportParam: '/api/mo-data/data/exportParam.action',
    }

    //批量导出参数值
    static exportParam = (params) => {
        return $exportAjax.post(`${this.data.exportParam}`, params).then(res => res);
    }

    //导出能耗数据列表
    static energyExport = (params) => {
        return $exportAjax.post(`${this.data.energyExport}`, params).then(res => res);
    }

    //库温数据
    static kuwenData = (params) => {
      return $ajax.post(`${this.data.kuwenData}`, params).then(res => res.data)
    }

    //冷风机电表能耗
    static fengjiData = (params) => {
      return $ajax.post(`${this.data.fengjiData}`, params).then(res => res.data)
    }

    //运行数据
    static yunxingData = (params) => {
      return $ajax.post(`${this.data.yunxingData}`, params).then(res => res.data)
    }

    //冷库详情摘要数据
    static freezerEnergy = (params) => {
      return $ajax.post(`${this.data.freezerEnergy}`, params).then(res => res.data)
    }

    //冷库能流分布图
    static freezerEnergyMeter = (params) => {
      return $ajax.post(`${this.data.freezerEnergyMeter}`, params).then(res => res.data)
    }

    //冷库能耗每年用电数据
    static freezerEnergyYear = (params) => {
      return $ajax.post(`${this.data.freezerEnergyYear}`, params).then(res => res.data)
    }

    //冷库能耗每日用电数据
    static freezerEnergyMonth = (params) => {
      return $ajax.post(`${this.data.freezerEnergyMonth}`, params).then(res => res.data)
    }

    //冷库能耗小时用电数据
    static freezerEnergyHours = (params) => {
      return $ajax.post(`${this.data.freezerEnergyHours}`, params).then(res => res.data)
    }


    //获取冷库综合态势数据
    static freezerZongHe = (params) => {
      return $ajax.post(`${this.data.freezerZongHe}`, params).then(res => res.data)
    }

    //项目关联电表设置
    static meterParent = (params) => {
      return $ajax.post(`${this.data.meterParent}`, params).then(res => res.data)
    }

    //项目关联电表查询
    static meterList = (params) => {
      return $ajax.post(`${this.data.meterList}`, params).then(res => res.data)
    }

    //能耗电表查询
    static deviceMeters = (params) => {
      return $ajax.post(`${this.data.deviceMeters}`, params).then(res => res.data)
    }

    //能耗数据统计查询（小时）
    static hourEnergy = (params) => {
      return $ajax.post(`${this.data.hourEnergy}`, params).then(res => res.data)
    }

    //能耗统计数据查询
    static staticEnergy = (params) => {
      return $ajax.post(`${this.data.staticEnergy}`, params).then(res => res.data)
    }

    // AI问答
    static aiAsk = (params) => {
      return $ajax.post(`${this.data.aiAsk}`, params).then(res => res.data)
    }
    
    // 操作事件列表
    static deviceEvents = (params) => {
      return $ajax.post(`${this.data.deviceEvents}`, params).then(res => res.data)
    }

    // 读取设备历史数据 按小时
    static readHoursParam = (params) => {
      return $ajax.post(`${this.data.readHoursParam}`, params).then(res => res.data)
    }

    // 读取设备历史数据 - 按天
    static readDateParams = (params) => {
      return $ajax.post(`${this.data.readDateParams}`, params).then(res => res.data)
    }

    // 读取设备最新数据
    static readDataLast = (params) => {
      return $ajax.post(`${this.data.readDataLast}`, params).then(res => res.data)
    }


}